import { Table } from "antd";
import { useQuery } from "react-query";
import DashboardMaster from "../dashboard/dashboard-master-layout.component";
import React, { ReactElement } from "react";
import { getArticleList } from "./article.thunks";
import { tableColumns } from "../../lib/helpers.table";
import { ArticleInterface } from "./article.interface";

const ArticleList = (): ReactElement => {
  const moduleName = "articles"; // we will use this as both the query name and the delete API endpoint
  const [page, setCurrentPage] = React.useState(0);

  const { data } = useQuery(
    [moduleName, { page }],
    () => getArticleList({ page }),
    { keepPreviousData: true }
  );

  const tableData = data ? data.docs : [];

  const pagination = {
    current: data?.page,
    pageSize: data?.limit,
    hideOnSinglePage: true,
    showSizeChanger: false,
    total: data?.totalDocs,
    onChange: (page) => {
      pagination.current = page; // updates table pagination
      setCurrentPage(page); // re-fetch the api
    },
  };

  const columnData = ["Title"];

  const columns = tableColumns(
    columnData,
    { field: "Title", url: `${moduleName}/` },
    { url: moduleName }
  );
  return (
    <>
      <DashboardMaster
        showAdd={true}
        title="Articles"
        addUrl={`/dashboard/${moduleName}/new`}
      >
        <Table
          rowKey={(doc: ArticleInterface) => doc._id}
          columns={columns}
          dataSource={tableData}
          pagination={pagination}
        />
      </DashboardMaster>
    </>
  );
};

export default ArticleList;
